import { DeadLetterListSchema, ReplayOutboxResponseSchema,
  ReplayWebhookResponseSchema, WebhookDeadLetterListSchema,
  type DeadLetterList, type ReplayOutboxResponse, type ReplayWebhookResponse,
  type WebhookDeadLetterList } from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listDeadLetters(token: string, afterId?: string): Promise<DeadLetterList> {
  const suffix = afterId ? `?afterId=${encodeURIComponent(afterId)}` : '';
  return DeadLetterListSchema.parse(await apiRequest(`/operations/outbox/dead-letters${suffix}`, token));
}

export async function listWebhookDeadLetters(token: string, afterId?: string): Promise<WebhookDeadLetterList> {
  const suffix = afterId ? `?afterId=${encodeURIComponent(afterId)}` : '';
  return WebhookDeadLetterListSchema.parse(await apiRequest(`/operations/webhooks/dead-letters${suffix}`, token));
}

export async function replayWebhookDeadLetter(token: string, input: { deliveryId: string;
  expectedGeneration: number; reason: string; key: string }): Promise<ReplayWebhookResponse> {
  return ReplayWebhookResponseSchema.parse(await apiRequest(
    `/operations/webhooks/dead-letters/${encodeURIComponent(input.deliveryId)}/replay`, token, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': input.key },
      body: JSON.stringify({ expectedGeneration: input.expectedGeneration, reason: input.reason.trim() }),
    }));
}

export async function replayDeadLetter(token: string, input: { messageId: string; expectedGeneration: number;
  reason: string; key: string }): Promise<ReplayOutboxResponse> {
  return ReplayOutboxResponseSchema.parse(await apiRequest(
    `/operations/outbox/dead-letters/${encodeURIComponent(input.messageId)}/replay`, token, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': input.key },
      body: JSON.stringify({ expectedGeneration: input.expectedGeneration, reason: input.reason.trim() }),
    }));
}
